import { Sort } from '@angular/material/sort';
import { RequestSort, RequestSortDirection } from '@src/app/generated/globalTypes';

export function feSortToBeSort(sort: Sort): RequestSort {
  switch (sort.direction) {
    case 'asc':
      return { column: sort.active, direction: RequestSortDirection.Ascending } as RequestSort;
    case 'desc':
      return { column: sort.active, direction: RequestSortDirection.Descending } as RequestSort;
    case '':
      return undefined;
  }
}
